export const TEXTS = {
  UPLOAD: 'Загрузить файл до 500Мб',
  FORMATS: 'Форматы файлов: .mp4, .jpg, .png',
  INVALID: 'Выберите MP4, JPG или PNG размером не более 500Мб',
};
